import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../../hooks/useLogout";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { StepHeader } from "../../Doctors/stepForm/StepHeader";
import LabStepHeader from "./LabStepHeader";
import { Form } from "reactstrap";
import MyInput from "../../../MyComp/UI/form/MyInput";
import { createLabProfileAPI, getLabDetailsOneAPI, getLabTypeDDAPI } from "../../../api/lab";
import { toast } from "react-toastify";
import MySelect from "../../../MyComp/UI/form/MySelect";
import { getZipDetailsAPI } from "../../../api/master/indes";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import MyButton from "../../../MyComp/UI/form/MyButton";
import MyEmail from "../../../MyComp/UI/form/MyEmail";
import MyGmailAddressSearch from "../../../MyComp/UI/form/MyGmailAddressSearch";

const LabProfile1 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      qualificationDD: [],
      specializationDD: [],

      objectionKeys: [],
      approvedKeys: [],

      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const doctorId = location?.state?.doctorId || "";
  const isLoading = watch("isLoading");

  
  useEffect(() => {
    getLabTypeDD();
  }, []);
  const getLabTypeDD = () => {
    getLabTypeDDAPI({})
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("labTypeDD", res.data.data);
          setValue("tableLoading", false);
        } else if (res.data.status === false) {
          setValue("tableLoading", false);
          setValue("cityDD", []);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("tableLoading", false);
          // toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("tableLoading", false);
        // toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (watch("pincode") && watch("pincode").toString().length === 6) {
      const body = {
        pin_code: watch("pincode"),
      };
      getZipDetails(body);
    }
  }, [watch("pincode")]);

  const getZipDetails = (body) => {
    getZipDetailsAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const responseData = res.data.data[0];
          console.log("zip details", responseData);
          setValue("city", responseData.district_name);
          setValue("state", responseData.state_name);
          trigger(["state","city"])
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const onFormSubmit = (data) => {
    const body = {
      name: watch("name"),
      mobile: watch("mobile"),
      email: watch("email"),
      contact_number: watch("contact_number"),
      alt_contact_number: watch("alt_contact_number"),
      pincode: watch("pincode"),
      city: watch("city"),
      state: watch("state"),
      address: watch("address"),
      person_name: watch("person_name"),
      country: "India",
      map_link: watch("map_link"),
      lab_type: watch("lab_type")?.map((item, index) => item.value),
      latitude: watch("latitude"),
      longitude: watch("longitude")
    };

    console.log("data", data, body);

    if (mode === "Add" || mode === "Edit") {
      createLabProfileAPI(body).then((res) => {
        if (res.data.status === true) {
          // navigate(`/laboratory-and-diagnostics/accreditation-and-compliance?labId=${res.data.data?.labId}`, {
          //   state: { mode: "Add" },
          // });
          navigate(`/laboratory-and-diagnostics/accreditation-and-compliance?labId=${res.data.data?.labId}`, {
            state: { mode: mode, labId: mode === "Add" ? res.data.data?.labId : location.state.labId },
          });
          toast.success(res.data.message);
          
          toast.clearWaitingQueue();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }
  };
  useEffect(() => {
    if (mode === "Edit") {
      getOneDetails();
    }
  }, [mode]);

  const getOneDetails = () => {
    getLabDetailsOneAPI({ labId: location.state.labId })
      .then((res) => {
        if (res.data.status === true) {
          const data = res.data.data;
          console.log("API DATA:", res.data.data);

          setValue("selectedAddress", { value: data?.address, label: data?.address });
          setValue("name", data.name);
          setValue("lab_type", data.lab_type);
          setValue("pincode", data.pincode);
          setValue("state", data.state);
          setValue("city", data.city);
          setValue("address", data.address);
          setValue("map_link", data.map_link);
          setValue("person_name", data.person_name);
          setValue("contact_number", data.contact_number);
          setValue("mobile", data.mobile);
          setValue("email", data.email);
          setValue("alt_contact_number", data.alt_contact_number);
          setValue("latitude", data.latitude)
          setValue("longitude", data.longitude)

          // If using validation
          // trigger();
        } else if (res.data.status === "expired") {
          logout();
        }
      })
      .catch(() => {
        setValue("tableLoading", false);
      });
  };
  

  return (
    <>
      <Head title={"Laboratory Registration | Lab & Diagnostics Profile"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Laboratory Registration"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <LabStepHeader current={1} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                <Col xs="12" sm="6" md="4" lg="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Lab Name"
                    name="name"
                    placeholder="Enter your lab name"
                    required
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Lab Type"}
                    name={"lab_type"}
                    placeholder={"Lab Type"}
                    required
                    multi
                    options={watch("labTypeDD")}
                  />
                </Col>
                <Col lg="6">
                  <MyGmailAddressSearch
                    value={watch("selectedAddress")}
                    onChange={(val) => setValue("selectedAddress", val)}
                    watch={watch}
                    setValue={setValue}
                    errors={errors}
                    trigger={trigger}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Pin Code"}
                    name={"pincode"}
                    placeholder={"Enter pin code"}
                    required
                    min={6}
                    max={6}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"State"}
                    name={"state"}
                    placeholder={"Select state"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"City"}
                    name={"city"}
                    placeholder={"Select city"}
                    // required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Lab Full Address"}
                    name={"address"}
                    placeholder={"Enter enter lab full address"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Google Map"}
                    name={"map_link"}
                    placeholder={"Enter google map link"}
                    // required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Contact Person"}
                    name={"person_name"}
                    placeholder={"Enter contact person name"}
                    required
                    
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Contact Number"}
                    name={"contact_number"}
                    placeholder={"Enter contact number"}
                    required
                      readOnly={mode == "Edit"}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Mobile Number"}
                    name={"mobile"}
                    placeholder={"Enter mobile number"}
                    required
                    
                       readOnly={mode == "Edit"}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    readonly={mode == "Edit"}
                    title={"Alternate Contact Number"}
                    name={"alt_contact_number"}
                    placeholder={"Enter alter contact number"}
                    // required
                    readOnly={mode == "Edit"}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyEmail
                    register={register}
                    watch={watch}
                    setValue={setValue} 
                    trigger={trigger}
                    errors={errors}
                    title="Email Address"
                    name="email"
                    placeholder="Enter Email Address"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Latitude"}
                    name={"latitude"}
                    placeholder={"Latitude"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Longitude"}
                    name={"longitude"}
                    placeholder={"Longitude"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
              </Row>
              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default LabProfile1;
